import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="21" height="20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M10.963 0c-5.52 0-10 4.48-10 10s4.48 10 10 10 10-4.48 10-10-4.48-10-10-10zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm3.88-11.71l-5.88 5.88-1.88-1.88a.996.996 0 10-1.41 1.41l2.59 2.59c.39.39 1.02.39 1.41 0l6.59-6.59a.996.996 0 000-1.41c-.39-.39-1.03-.39-1.42 0z" fill="#007B00" /></svg>;